import axios from '@/utils/request'
const urlPrefix = 'map'
// 新建区域数据
export function addArea (data) {
  return axios({
    url: urlPrefix + '/area',
    method: 'post',
    data: data
  })
}
// 更新区域
export function updateArea (data) {
  return axios({
    url: urlPrefix + '/area',
    method: 'put',
    data: data
  })
}
// 删除区域
export function delArea (data) {
  return axios({
    url: urlPrefix + '/area',
    method: 'delete',
    data: data
  })
}
// 获取单个区域详细信息
export function getArea (params) {
  return axios({
    url: urlPrefix + '/area',
    method: 'get',
    params: params
  })
}
// 获取区域列表
export function getArealList (params) {
  return axios({
    url: urlPrefix + '/area/list',
    method: 'get',
    params: params
  })
}
export function sortArea (data) {
  return axios({
    url: urlPrefix + '/area/order',
    method: 'put',
    data: data
  })
}
export async function getAreaTree (params) {
  // const { data } = await axios({
  //   url: urlPrefix + '/area/list',
  //   method: 'get',
  //   params: params
  // })
  // const res2 = await axios({
  //   url: urlPrefix + '/area/list',
  //   method: 'get',
  //   params: params
  // })
  // const sortList = res2.sort
}
// 获取区域分页
export function getAreaPage (params) {
  return axios({
    url: urlPrefix + '/area/page',
    method: 'get',
    params: params
  })
}
// 获取区域分页
export function moveArea (data) {
  return axios({
    url: urlPrefix + '/area/move',
    method: 'put',
    data: data
  })
}
